import { Alert, AlertTitle, Box, Button, CircularProgress } from "@mui/material";
import { useIotDetekceStavQuery, useZapnoutIotDetekciMutation } from "../../api/JsdhNotifikaceService/service/IotMutations";
import { useAuthStore } from "../../store/auth-store";

/**
 * Banner zobrazeny pokud je globalne vypnuto vyhlasovani z IoT/SIA detekce.
 * Pro neautentizovane uzivatele se nezobrazuje.
 * KOPIS poplachy nejsou ovlivneny.
 */
const IotDetekceVypnutaBanner = () => {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const isAdmin = useAuthStore((s) => s.isAdmin);
    const { data, isLoading, isError } = useIotDetekceStavQuery();
    const zapnoutMutation = useZapnoutIotDetekciMutation();

    if (!isAuthenticated || isLoading || isError || !data) {
        return null;
    }
    if (data.currentlyEnabled) {
        return null;
    }

    const expireText = data.disabledDo
        ? `do ${new Date(data.disabledDo).toLocaleString("cs-CZ", { dateStyle: "short", timeStyle: "short" })}`
        : "trvale";
    const duvodText = data.disabledDuvod ? ` (důvod: ${data.disabledDuvod})` : "";

    return (
        <Alert
            severity="error"
            variant="filled"
            sx={{
                borderRadius: 0,
                "& .MuiAlert-message": { flex: 1 },
            }}
            action={
                isAdmin && (
                    <Button
                        color="inherit"
                        size="small"
                        onClick={() => zapnoutMutation.mutate()}
                        disabled={zapnoutMutation.isPending}
                        startIcon={zapnoutMutation.isPending ? <CircularProgress size={14} color="inherit" /> : null}
                    >
                        Zapnout
                    </Button>
                )
            }
        >
            <AlertTitle sx={{ fontWeight: 700 }}>
                POZOR: Vyhlašování poplachů z IoT/SIA detekce je VYPNUTO {expireText}
            </AlertTitle>
            <Box>
                Detektory kouře, CO, EPS/EZS panely apod. <strong>nepovedou k vyhlášení poplachu</strong>.
                KOPIS poplachy fungují normálně.{duvodText}
            </Box>
        </Alert>
    );
};

export default IotDetekceVypnutaBanner;
